import Vue from 'vue'
import VueMeta from 'vue-meta'
import store from '../store.js'
import Validation from '@/services/validation'
import VueResource from 'vue-resource'
import DiagInfo from '@/components/core/dialogs/DiagInfo'
import Topper from '@/components/core/Topper'

Vue.component('DiagInfo', DiagInfo)
Vue.component('Topper', Topper)

Vue.use(VueResource)
Vue.use(VueMeta)

Vue.mixin({
    methods: {
        validateIsEmpty(item) {
            return Validation.isEmpty(item);
        },
        validateIsEmail(item) {
            return Validation.isEmail(item);
        },
        msgSuccess(msg) {
            store.dispatch('setSnack', {kind:'success', text:msg});
        },
        msgError(error) {
            if (error == null) error = 'Hubo un error, por favor intente más tarde.';
            store.dispatch('setSnack', {kind:'error', text:error});
        }
    }
})

